import * as angular from "angular";
import {IController} from "angular";


export class CommissionPackagesBarcodeComponent implements IController {

  packages: any;

  public barcodes: string[];

  constructor() {

  }

  $onInit() {
    this._initBarcodes();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.packages && !changes.packages.isFirstChange()) {
      this._initBarcodes();
    }
  }

  private _initBarcodes() {
    this.barcodes = this.packages?.filter(p => !!p.barcode).map(p => p.barcode);
  }

}

angular
  .module('bringoz.admin.commissions')
  .component('commissionPackagesBarcode', {
    bindings: {
      packages: '<',
    },
    template: require('./commission-packages-barcode.html').default,
    controller: CommissionPackagesBarcodeComponent
  });
